import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import FilterSwitch from './FilterSwitch'

export default function SlideFeaturesFiltersSwitch(props) {

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography sx={{ fontWeight: 'bold' }}>Filtres</Typography>
      </AccordionSummary>
      <AccordionDetails style={{maxHeight: '150px', overflow: 'auto'}}>
        {props.slideFeatureFilters.current.map((slideFeatureFilter, index) => (
          <FilterSwitch key={index} slideFeatureFilter={slideFeatureFilter} activeFeatureFilters={props.activeFeatureFilters}
          activeFeatureFiltersChanged={props.activeFeatureFiltersChanged} featureFiltersChanged={props.featureFiltersChanged} assetsNumber={props.assetsNumberByFilter.get(slideFeatureFilter.name)}
          centerOnRandomFeatureForFilter={props.centerOnRandomFeatureForFilter} selectFeaturesForFilter={props.selectFeaturesForFilter}/>
        ))}
      </AccordionDetails>
    </Accordion>
  )
}